<template>
  <div id="app">
    <Header/>
    <router-view ref="child"/>
    <Footer/>
  </div>
</template>

<script>
import Header from './components/Header'
import Footer from './components/Footer'

export default {
  name: 'app',
  components: {
    Header,
    Footer
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>

<style>

@import url(https://fonts.googleapis.com/css?family=Nunito);

/*!
 * Bootstrap v4.1.2 (https://getbootstrap.com/)
 * Copyright 2011-2018 The Bootstrap Authors
 * Copyright 2011-2018 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 */

.search_icon {
  max-width: 40px;
  min-width: 40px;
  max-height: 40px;
  min-height: 40px;
  background-color: rgb(237, 187, 75);
  border-radius: 0.5rem;
}

.table-responsive td a {
  text-decoration: none!important;
}

.card-body span,
.card-body div,
.card-body strong,
.card-body a{
  text-decoration: none!important;
}

.vue-star-rating-pointer {
  margin-bottom: 4px;
}

.btn-primary {
  background-color: #edbb4b!important;
  border-color: #edbb4b!important;
}
.btn-primary:hover {
  background-color: #dcad44!important;
  border-color: #dcad44!important;
}

.btn-success {
  background-color: #edbb4b!important;
  border-color: #edbb4b!important;
}

.btn-info {
  background-color: #edbb4b!important;
  border-color: #edbb4b!important;
}
.btn-info:hover {
  background-color: #dcad44!important;
  border-color: #dcad44!important;
}

.btn-info2 {
  background-color: rgb(251, 252, 173)!important;
  border-color: rgb(251, 252, 173)!important;
  color: #a9a9a9!important;
}
.btn-info2:hover {
  background-color: rgb(244 245 146)!important;
  border-color: rgb(244 245 146)!important;
  color: #a9a9a9!important;
}

strong {
  font-weight: bold!important;
}

.balloon {
  position: relative;
  background-color: #d5fffb;
  padding: 10px;
  color: #6c6c6c;
  font-size: 0.9rem;
  border-radius: 4px;
}

.balloon::before {
  content: "";
  position: absolute;
  border: 12px solid transparent;
  border-top: 12px solid #d5fffb;
  top: 100%;
  left: 5%;
}

.balloon p {
  margin: 0;
  padding: 0;
}

/* ページネーション */
.pagination li{
  width:50px;
  height:50px;
  margin:2px;
  line-height:50px;
  text-align:center;
  font-size:14px;
  font-weight:bold;
  text-decoration:none;
  background:#fff;
  color:#222;
  transition:.3s;
}
.pagination li:hover{
  background:#f2f39b;
  border-radius:100%;
  transform:rotate(360deg);
}
.pagination .active{
  background:#fbfcad;
  border-radius:100%;
}


a {
  cursor: pointer;
}

#progress div.li {
    padding: 6px 20px;
    border-radius: 8px;
    background-color: #d0d0d0;
    border: solid 1px #a8a8a8;
}

#progress div.li.active {
    padding: 6px 20px;
    border-radius: 8px;
    background-color: #9effb0;
    border: solid 1px #0ddb5f;
}

/* PC */
@media (min-width: 992px) {
  /* メニューボタン非表示 */
  #menubtn,
  .b-sidebar-backdrop {
    display: none;
  }
}

.pagination .page-item .page-link, .pagination .page-item .page-link:hover {
  border-radius: 20px;
}

.pagination .page-item.active .page-link {
  border-radius: 20px;
  background-color: #7bd556;
}

.pagination .page-item.active .page-link:hover {
  background-color: #48b32d;
}

.pankuzu ul {
  padding-left: 0;
  font-size: 0.8rem;
}

.pankuzu ul li {
  display: inline;
  list-style: none;
  font-weight: bold;
}

.pankuzu ul li:after {
  content: '>';
  padding: 0 3px;
  color: #555;
}

.pankuzu ul li.conditions_wrap:after {
  content: '';
  padding: 0 3px;
  color: #555;
}

.pankuzu ul li:last-child:after {
  content: '';
}

.pankuzu ul li a {
  font-size: 0.8rem!important;
  text-decoration: none!important;
  color: gray!important;
}

/*
.pankuzu ul li:first-child a:before {
  font-family: FontAwesome;
  content: '\f015';
  font-weight: normal;
  font-size: 1.1em;
  color: #edbb4b;
}
*/

.pankuzu ul li a:hover {
  text-decoration: underline;
}

.table th, .table td {
  padding: 15px;
}

.table tr:nth-child(odd) {
  background: #E7EBE9;
}

.table tr:nth-child(even) {
  background: #F8F8F8;
}

.table tr:first-child {
  background: #231916;
}

.table th {
  color: #fff;
  /* border-bottom: solid 1px #231916;*/
  border-bottom: 1px solid #dedede;
}

.table td {
  color: #4A6458;
  /* border-bottom: solid 1px #231916;*/
  border-bottom: 1px solid #dedede;
}

.p-table th, .p-table td {
  padding: 15px;
}

.p-table tr:nth-child(odd) {
  background: #fafafa;
}

.p-table tr:nth-child(even) {
  background: #F8F8F8;
}

.p-table tr:first-child {
  background: #231916;
}

.p-table th {
  color: #5f6060;
  border-bottom: solid 1px #231916;
}

.p-table td {
  color: #4A6458;
  border-bottom: solid 1px #231916;
}

.card-img-best-parent {
  overflow: hidden;
}

.card-img-best:hover {
  transform: scale(1.5);
  transition-duration: 0.3s;
}

.card-img-best {
  transition-duration: 0.3s;
  max-width: 100%;
  max-height: 160px;
}

.text_3_min {
  margin: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  min-height: 4rem;
  overflow: hidden;
}

.text_6_min {
  margin: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 6;
  min-height: 8rem;
  overflow: hidden;
}

.modaal-wrapper .modaal-close {
  position: absolute;
  top: -15px;
  right: -15px;
  background: yellowgreen!important;
}

.modaal-container {
  border-radius: 6px!important;
}

.main_search_type.top_modal input {
  display: none;
}

.main_search_type.top_modal label {
  display: block;
  float: left;
  cursor: pointer;
  width: 80px;
  margin: 0;
  padding: 12px 5px;
  border-right: 1px solid #abb2b7;
  background: #bdc3c7;
  color: #555e64;
  font-size: 14px;
  text-align: center;
  line-height: 1;
  transition: .2s;
}

.main_search_type.top_modal label:first-of-type {
  border-radius: 3px 0 0 3px;
}

.main_search_type.top_modal label:last-of-type {
  border-right: 0px;
  border-radius: 0 3px 3px 0;
}

.main_search_type.top_modal input[type="radio"]:checked+label {
  background-color: rgb(237, 187, 75);
  color: #fff;
}


/* cp pulldown */

.cp_ipselect {
  overflow: hidden;
  width: 99%;
  /*margin: 2em auto;*/
  text-align: center;
}

.cp_ipselect select {
  width: 100%;
  padding-right: 1em;
  cursor: pointer;
  text-indent: 0.01px;
  text-overflow: ellipsis;
  border: none;
  outline: none;
  background: transparent;
  background-image: none;
  box-shadow: none;
  -webkit-appearance: none;
  appearance: none;
}

.cp_ipselect select::-ms-expand {
  display: none;
}

.cp_ipselect.cp_sl01 {
  position: relative;
  border: 1px solid #bbbbbb;
  border-radius: 2px;
  background: #ffffff;
}

.cp_ipselect.cp_sl01::before {
  position: absolute;
  top: 0.8em;
  right: 0.9em;
  width: 0;
  height: 0;
  padding: 0;
  content: '';
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #666666;
  pointer-events: none;
}

.cp_ipselect.cp_sl01 select {
  padding: 8px 38px 8px 8px;
  color: #666666;
}


/* cp pulldown */

.d-sp {
  display: none!important;
}

.d-pc {
  display: block!important;
}

/* PC メニュー **/

.b-sidebar-outer {
  display: none;
}

ul.sidenav {
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: 200px;
  border-radius: 8px;
  border: solid 2px #dbdbdb;
  background-color: #ffffff;
  position: relative;
  overflow: auto;
}
ul.sidenav li a {
  display: block;
  color: #000000;
  padding: 8px 16px;
  text-decoration: none;
}
ul.sidenav li a.active {
  background-color: #fbfcad;
  color: #000;
}
ul.sidenav li a:hover:not(.active) {
  background-color: #f2f2f2;
  color: #000;
}

@media (max-width: 992px) {
  .d-sp {
    display: block!important;
  }
  .d-pc {
    display: none!important;
  }
  /* スマホ メニュー **/
  .b-sidebar {
    background-color: aliceblue;
  }
  .b-sidebar-outer {
    display: block;
  }
  .menu-btn {
    background-color: white!important;
    border: white!important;
    box-shadow: none!important;
  }

  .container {
    padding-right: 0px!important;
    padding-left: 0px!important;
  }

}

.article-font-01 {
  color: #1d731d;
  font-size: 0.9rem;
  font-weight: bold;
}

.kakomi-tape3 {
  position: relative;
  padding: 35px 20px 15px;
  margin: auto;
  width: 100%;
  color: #555555;
  /* 文字色 */
  background-color: #d7f3c2;
  box-shadow: inset 0 0 40px rgb(172, 227, 163), 0 2px 2px #82aa7c;
}

.title-tape3 {
  position: absolute;
  top: -15px;
  left: 20px;
  padding: 4px 10px;
  color: #555555;
  /*タイトル色*/
  font-weight: bold;
  background-color: rgba(255, 255, 255, .4);
  border-left: 2px dotted rgba(0, 0, 0, .1);
  border-right: 2px dotted rgba(0, 0, 0, .1);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
  transform: rotate(-5deg);
}

.non_read {
  background-color: #75e97e;
  color: #ffffff;
  padding: 4px;
  border-radius: 4px;
  font-weight: bold;
}

.br::before {
  content: "\A";
  white-space: pre;
}

.btn-font-1 {
  border-radius: 4px;
  color: #fefefe;
  background-color: #ff931e;
}

.pointer {
  cursor: pointer;
}


/* pc_search_menu */

.pc-only-i {
  display: inline-block!important;
}

.sp-only-i {
  display: none!important;
}

.sp_menu {
  display: none;
}


/* sp_search_menu */

@media only screen and (max-width: 764px) {
  .sp_menu {
    display: block;
  }
  .sp-only-i {
    display: inline-block!important;
  }
  .view img {
    right: 0%!important;
  }
  .main_image {
    max-width: 100%!important;
    width: 100%!important;
  }
  .pc-only-i {
    display: none!important;
  }
}


/* text-color */

.text-color-1 {
  color: #ef662e!important;
}

.text-color-2 {
  color: #a5a5a5!important;
}

.text-color-3 {
  color: #212529!important;
}

/* long text ... */

.ellipsis_text {
  overflow: hidden;
  height: 1.5rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}


/* review_box */

.review_box {
  overflow: hidden;
  max-height: 160px!important;
  min-height: 160px!important;
}


/* image */

.img-thumbnail {
  overflow: hidden;
  max-height: 200px;
}


/* year month day hour minute */

.year {
  display: inline-block !important;
  width: 80px;
}

.month {
  display: inline-block !important;
  width: 60px;
}

.day {
  display: inline-block !important;
  width: 60px;
}

.hour {
  display: inline-block !important;
  width: 60px;
}

.minute {
  display: inline-block !important;
  width: 60px;
}


/* org_tab */

.org_tab {
  cursor: pointer;
}

.org_tab.active {
  border-bottom: solid 2px #00bdd1!important;
}

.org_tab.active span {
  font-weight: 700!important;
}

.org_tab_contents {
  display: none;
}

.org_tab_contents.active {
  display: block;
}

.card .card-body .card-text {
  font-size: .9rem;
  font-weight: 400;
}

.card .card-body .card-text, .dark-grey-text {
  color: #4f4f4f;
}

/* more button */

.more_btn {
  position: relative;
  display: inline-block;
  font-weight: bold;
  padding: 12px 0 8px;
  text-decoration: none;
  color: #878787;
  transition: .4s;
  font-size: 0.9rem;
  width: 100px;
  text-align: center;
}

.more_btn:before {
  position: absolute;
  content: '';
  width: 100%;
  height: 2px;
  top: 100%;
  left: 0;
  border-radius: 3px;
  background: #838383;
  transition: .2s;
}

.more_btn:after {
  position: absolute;
  content: '';
  width: 100%;
  height: 2px;
  top: 0;
  left: 0;
  border-radius: 3px;
  background: #838383;
  transition: .2s;
}

.more_btn:hover:before {
  top: -webkit-calc(100% - 3px);
  top: calc(100% - 3px);
}

.more_btn:hover:after {
  top: 3px;
}


/* top button */

a.org_btn {
  position: relative;
  display: block;
  width: 100px;
  padding: 0.6em;
  text-align: center;
  font-weight: bold;
  text-decoration: none;
  color: #f9fff8;
  font-size: 0.8rem;
}

a.org_btn:before {
  position: absolute;
  content: '';
  width: 100%;
  height: 4px;
  top: 100%;
  left: 0;
  border-radius: 3px;
  background: #f2f39b;
  transition: .4s;
}

a.org_btn.l:before {
  background: #dcad44;
}

a.org_btn:hover:before {
  top: calc(100% - 3px);
}

a.a-style-1 {
  -webkit-transition: all 0.3s ease !important;
  -moz-transition: all 0.3s ease !important;
  -o-transition: all 0.3s ease !important;
  transition: all 0.3s ease !important;
}

a.a-style-1:hover {
  background-color: whitesmoke;
  color: #999 !important;
}

img {
  max-width: 100%;
  height: auto;
  width/***/
  : auto;
}

html {
  -webkit-overflow-scrolling: touch;
}


/* message css */

.send_message_area {
  background-color: white;
  border-radius: 1rem;
}

.from_user_comment {
  display: inline-block;
  /*background-color: white;*/
  background-color: #f3f3f3;
  border-radius: 1rem;
}

.to_user_comment {
  display: inline-block;
  background-color: #ffdfaf;
  border-radius: 1rem;
}

.text-ellipsis {
  overflow: hidden;
  max-width: 10rem;
  width: 10rem;
}

.text-ellipsis p {
  overflow: hidden;
  max-width: 10rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hide {
  display: none;
}


/* review text */

.review-text {
  overflow: hidden;
  max-height: 7.2rem !important;
}

.review-text::after {
  position: absolute;
  bottom: 0;
  left: 0.5rem;
  z-index: 2;
  content: '';
  width: 99%;
  height: 50%;
  background: linear-gradient(rgba(255, 255, 255, 0) 0, #fff 90%, #fff 100%);
}


/* 5 star css */

/* input textarea padding */

input[type="text"], input[type="password"], input[type="tel"], input[type="email"], textarea, select {
  font-size: 16px;
  /*transform: scale(0.8);*/
  padding: 0.5rem !important;
  border-radius: 6px;
  border: solid 1px #bbb7b7;
  /*background-color: #f3f3f3;*/
}


/* button width 100% */

.b100 .waves-input-wrapper {
  width: 100%;
}

.b100 .waves-input-wrapper .bs100, .b100 .bs100 {
  width: 100%;
  margin-left: auto;
}


/* haikei */

body {
  background-origin: padding-box;
  background-color: #fff;
}

.sp-nav {
  display: none;
}

.dash_logo {
  display: none;
}

.head-nav, .page-footer, .top-nav-collapse {
  background-color: #effff5 !important;
}

.page-footer {
  background-color: #edbb4b !important;
}

.head-nav, .scrolling-navbar.top-nav-collapse {
  box-shadow: unset;
  border-bottom: solid 2px #fbfbfb;
  background-color: #fdfdfd !important;
  background-position: 0 0, 0 0, 10px -20px, 10px -20px;
  background-size: 20px 40px;
}


/* sp */

@media only screen and (max-width: 992px) {
  #res_menu {
    background-color: #ceffc6!important;
    background-color: #fdfdfd !important;
    height: 60px!important;
  }
  .search_width {
    width: 80%!important;
  }
  .navbar, .top-nav-collapse {
    background-color: #fdfdfd !important;
    background-position: 0 0, 0 0, 10px -20px, 10px -20px;
    background-size: 20px 40px;
  }
}

@media only screen and (max-width: 992px) {
  .dash_logo {
    display: block;
  }
  .head-sp-nav {
    height: 60px;
  }
  .sp-nav {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    width: 50%;
    float: right;
    list-style: none;
    margin: 0;
    padding: 0;
    max-width: 120px;
    /*max-width: 180px;*/
    box-sizing: border-box;
  }
  .sp-nav-child {
    /*    border-bottom: solid 2px #b4ebbd;*/
    /*    border-bottom: solid 2px #f7f7f7;*/
    border-bottom: solid 2px #fbfbfb;
    position: relative;
    background-color: rgba(255, 255, 255, 0.2);
    float: left;
    /*    border-left: 1px dotted #848484;*/
    width: 50%;
    /*width: 33.3%;*/
    height: 60px;
    max-width: 60px;
    box-sizing: border-box;
  }
  .sp-icon {
    font-size: 1.5rem;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto 0;
  }
  .sp-icon-font {
    color: #888888;
    position: absolute;
    bottom: 3px;
    font-size: 0.6rem;
    text-align: center;
    left: 0;
    right: 0;
  }
  .icon-parent {
    position: absolute;
    left: 0;
    right: 0;
    margin: 0 auto;
    text-align: center;
    top: 10px;
  }
  .sp-dummy {
    background-color: rgba(0, 0, 0, 0);
    border-left: 0px;
  }
  .sp-regist .sp-icon, .sp-mypage .sp-icon {
    color: #3c9f41;
  }
  .sp-login .sp-icon, .sp-logout .sp-icon {
    color: #929292;
  }
  .sp-menu .sp-icon {
    color: #b0de34;
  }
  /* dashboard */
  .off-canvas-sidebar nav .navbar-collapse:before, .sidebar:before {
    background-color: #ececec !important;
  }
  /* mar_agency init regist card */
  .modaal-content-container, .sp-form-container {
    padding: 0px !important;
  }
  form[name="init_regist"] .card-body, form[name="mar_agencies_edit"] .card-body, form[name="counselors_edit"] .card-body, .dashboard_form .card-body {
    padding: 0.4rem !important;
  }
  img {
    width: auto;
    height: auto;
  }
}


/* mar_agency init regist */

form[name="init_regist"] .form-control, form[name="init_regist"] .is-focused .form-control, form[name="mar_agencies_edit"] .form-control, form[name="mar_agencies_edit"] .is-focused .form-control, form[name="counselors_edit"] .form-control, form[name="counselors_edit"] .is-focused .form-control, .dashboard_form .form-control, .dashboard_form .is-focused .form-control {
  background-image: linear-gradient(0deg, #a8ffa2 2px, rgba(156, 39, 176, 0) 0), linear-gradient(0deg, #d2d2d2 1px, hsla(0, 0%, 82%, 0) 0);
}


/* form required */

.required_mark {
  background-color: #ff7696;
  color: white;
  padding: 2px;
  border-radius: 4px;
  font-size: 0.8rem;
}


/* form representative */

.representative_mark {
  background-color: #ff7696;
  color: white;
  padding: 2px;
  border-radius: 4px;
  font-size: 0.8rem;
}


/* right bottom */

.rb {
  position: absolute!important;
  bottom: 0;
  right: 0;
}


/* right top */

.rt {
  position: absolute!important;
  top: 0;
  right: 0;
}


/* left bottom */

.lb {
  position: absolute!important;
  bottom: 0;
  left: 0;
}


/* left top */

.lt {
  position: absolute!important;
  top: 0;
  left: 0;
}


/* left center */

.lc {
  position: absolute!important;
  top: 50%;
  left: 0;
  transform: translateY(-50%) translateX(-50%);
  -webkit-transform: translateY(-50%) translateX(-50%);
}


/* right center */

.rc {
  position: absolute!important;
  top: 50%;
  right: 0;
  transform: translateY(-50%) translateX(-50%);
  -webkit-transform: translateY(-50%) translateX(-50%);
}


/* center */

.cc {
  position: absolute!important;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  -webkit-transform: translateY(-50%) translateX(-50%);
}


/* custom height */

.h5 {
  height: 5rem;
}

.h4 {
  height: 4rem;
}

.h3 {
  height: 3rem;
}

.h2 {
  height: 2rem;
}

.h1 {
  height: 1rem;
}


/* 本人確認 */

.identification_font {
  color: #54ee46;
  font-size: 1.2rem;
}

.not_identification_font {
  color: #ff3d3d;
  font-size: 1.2rem;
}

.z_inmax {
  z-index: 10000;
}


/* PC */

@media only screen and (min-width: 992px) {
  /* 悩む */
  .main-panel>.content {
    margin-top: 0px !important;
  }
}


/* courses */

.status_active, .sort_active, .type_active {
  color: white;
  background-color: #5ee76f;
}

.status_none, .sort_none, .type_none {
  color: #5e52ff;
}


/* NEW */

.ribbon18 {
  display: inline-block;
  position: absolute;
  left: 0;
  top: 10px;
  box-sizing: border-box;
  padding: 0 5px;
  margin: 0;
  height: 16px;
  line-height: 16px;
  font-size: 18px;
  letter-spacing: 0.1em;
  color: white;
  background: #ff7470;
  box-shadow: 1px -1px 1px rgba(0, 0, 0, 0.1);
  font-size: 0.8rem;
}

.ribbon18:before {
  position: absolute;
  content: '';
  top: -8px;
  left: -7px;
  border: none;
  height: 24px;
  width: 7px;
  background: #ff7470;
  border-radius: 5px 0 0 5px;
}

.ribbon18:after {
  position: absolute;
  content: '';
  top: -7px;
  left: -5px;
  border: none;
  height: 7px;
  width: 5px;
  background: #b25552;
  border-radius: 5px 0 0 5px;
}

@media all and (-ms-high-contrast: none) {
  html {
    display: flex;
    flex-direction: column;
  }
  body {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
}

/*
#app {
    font-family: "Noto Sans CJK JP";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 70px;
}

@media screen and (max-width: 575px) {
  #app {
    margin-top: 50px;
  }
}
*/

a {
  font-size: 0.9rem;
}

.btn {
  font-size: 0.9rem;
}

</style>



// WEBPACK FOOTER //
// src/App.vue